import { render, staticRenderFns } from "./straightDownPrice.vue?vue&type=template&id=642ae75a&scoped=true&"
import script from "./straightDownPrice.vue?vue&type=script&lang=js&"
export * from "./straightDownPrice.vue?vue&type=script&lang=js&"
import style0 from "./straightDownPrice.vue?vue&type=style&index=0&id=642ae75a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ae75a",
  null
  
)

export default component.exports